import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import loderLogo from "../../API/Interceptor/loderLogo.png";
import loader from "../../API/Interceptor/load.json";

const PageLoader = () => {
    return (
        <div className="loaderCss">
           
                <section className="loader-wrapper">
                    <Player
                        autoplay
                        loop
                        src={loader}
                        style={{ height: "600px", width: "600px" }}
                    ></Player>
                    <img
                        src={loderLogo}
                        alt="logoLoder"
                        style={{ borderRadius: "50%" }}
                    />
                </section>
           
        </div>
    )
}

export default PageLoader;